<template>
  <b-btn
    variant="link"
    class="vt-icon-btn--grey--xs"
    :disabled="disabled"
    tabindex="-1"
    :title="$t('component.studyRequest.subRequestForm.selectToClone')"
    :qa="qa + '-' + activated"
    @click="toggle"
  >
    <fa-icon
      :icon="icon"
      size="xs"
      :class="{'main': activated}"
    />
  </b-btn>
</template>

<script>

import { findIndex } from 'lodash'

export default {
    name: 'VtCloneToggle',
    props: {
        value: { type: Array, default: () => [] },
        field: { type: String, required: true },
        disabled: { type: Boolean, default: false },
        qa: { type: String, required: false }
    },
    computed: {
        activated() {
            return findIndex(this.value, v => v === this.field) !== -1
        },
        icon() {
            return this.activated ? ['fas', 'clone'] : ['fal', 'clone']
        }
    },
    methods: {
        toggle() {
            const copy = this.value.slice()
            if (this.activated) {
                const index = findIndex(copy, v => v === this.field)
                copy.splice(index, 1)
            } else {
                copy.push(this.field)
            }
            this.$emit('input', copy)
        }
    }
}

</script>

<style scoped lang="scss">

.vt-icon-btn--grey--xs {
  color: vt-color(grey);
  border-radius: 50%;
  padding: 0rem 0.376rem;

  &:hover {
    color: vt-color(primary);
    background-color: vt-color(light-primary);
  }
}

</style>
